"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import styled from "styled-components";
const SVG = styled.svg`
  min-width: ${({ $size }) => $size};
  max-width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
`;
const X = ({ size = "1em", color = "currentColor", title, ...props }) => /* @__PURE__ */ jsxs(SVG, { ...props, $size: size, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", role: title ? "img" : "presentation", children: [
  title ? /* @__PURE__ */ jsx("title", { children: title }) : null,
  " ",
  /* @__PURE__ */ jsx("path", { fill: color, d: "M13.68 11.6 20.23 4h-1.55l-5.7 6.62L8.44 4H3.19l6.88 10-6.88 8h1.56l6-7 4.81 7h5.25l-7.13-10.4Zm-2.13 2.48L5.3 5.16h2.38l10.99 15.71h-2.39l-4.74-6.79Z", children: " " })
] });
var X_default = X;
export {
  X_default as default
};
